// extracted by mini-css-extract-plugin
export default {"variantError":"styles_variantError__CaFkH","variantBIGSuccess":"styles_variantBIGSuccess__EFual","root":"styles_root__HHsUM","containerRoot":"styles_containerRoot__E45L6"};